export default "https://assets.pclncdn.com/web/next-landing/62eec7c/_next/static/images/san-diego-990b784ec75d983ee6f2b232c02fdf83.jpg";